
<template>
<div>
	<label>{{labelName}}</label>
	<div class="input-group mb-3 color-picker" ref="colorpicker">
		<div class="input-group-prepend">
			<div v-if="displayPicker" ref="pickerPopup" :style="pickerStyle" class="color-picker-popup">
				<client-only><chrome-picker :value="colors" @input="updateFromPicker" /></client-only>
			</div>
			<a class="btn btn-outline-secondary dropdown-toggle" @click.stop="togglePicker()">
				<span class="current-color" :style="'background-color: ' + colorValue"></span>
			</a>
		</div>
		<input type="text" maxlength="50" class="form-control" v-model="colorValue" @focus="showPicker()" @input="updateFromInput" />
	</div>
</div>
</template>

<script>

export default {

	props: ['color','label'],
	data() {
		return {
			colors: {
				hex: '#000000',
			},
			labelName:this.label?this.label:this.$t('pickers.color_font'),
			colorValue: '',
			displayPicker: false,
		    defaultColor: '#FF0000',
		    pickerStyle: {}
		}
	},
	mounted() {
		this.setColor(this.color || '#000000');
	},
	methods: {
		setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
		updateColors(color) {
			if(color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			}
			else if(color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
					hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3],
				}
			}
		},
		showPicker() {
			this.$store.state.isLiveEditing = true;
			// Calculamos la posicion ANTES de mostrar el popup. El trigger
			// (this.$refs.colorpicker) siempre esta en el DOM, asi que podemos medir
			// sin esperar al render del popup. Si se hace en $nextTick, en la primera
			// apertura el popup se pinta un frame con pickerStyle vacio (cae en el
			// flujo normal, abajo) y recien despues se reposiciona.
			if (this.$refs.colorpicker) {
				const rect = this.$refs.colorpicker.getBoundingClientRect();
				// El chrome-picker mide ~240px de alto. Preferimos abrirlo ARRIBA
				// del campo (queda sobre "Color de fondo" y no tapa los controles
				// de abajo). Si no hay lugar arriba, fallback hacia abajo.
				const pickerHeight = 240;
				const openAbove = rect.top >= pickerHeight + 8;
				this.pickerStyle = {
					position: 'fixed',
					left: rect.left + 'px',
					zIndex: 100000,
					...(openAbove
						? { bottom: (window.innerHeight - rect.top + 4) + 'px' }
						: { top: (rect.bottom + 4) + 'px' })
				};
			}
			this.displayPicker = true;
			document.addEventListener('click', this.documentClick);
			document.addEventListener('scroll', this.hidePicker, true);
		},
		hidePicker() {
			document.removeEventListener('click', this.documentClick);
			document.removeEventListener('scroll', this.hidePicker, true);
			this.displayPicker = false;
			this.$store.state.isLiveEditing = false;
			this.$emit('input', '');
			this.$emit('input', this.colorValue);
		},
		togglePicker() {
			this.displayPicker ? this.hidePicker() : this.showPicker();
		},
		updateFromInput() {
			this.updateColors(this.colorValue);
		},
		updateFromPicker(color) {
			this.colors = color;
			if(color.rgba.a == 1) {
				this.colorValue = color.hex;
			}
			else {
				this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
			}
		},
		documentClick(e) {
			const trigger = this.$refs.colorpicker;
			const popup = this.$refs.pickerPopup;
			const target = e.target;
			const insideTrigger = trigger && (trigger === target || trigger.contains(target));
			const insidePopup = popup && (popup === target || popup.contains(target));
			if (!insideTrigger && !insidePopup) {
				this.hidePicker();
			}
		}
	},
	watch: {
		colorValue(val) {
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
			}
		}
	},
	beforeDestroy() {
		document.removeEventListener('click', this.documentClick);
		document.removeEventListener('scroll', this.hidePicker, true);
	}
}
</script>

<style>

.current-color {
	display: block;
	width: 100%;
	height: 100%;
	min-width: 24px;
	min-height: 24px;
	background-color: #000;
	cursor: pointer;
	border-radius: 3px;
}

.color-picker-popup {
	z-index: 100000;
	animation: cpFadeIn 0.12s ease;
}

@keyframes cpFadeIn {
	from { opacity: 0; transform: translateY(-4px); }
	to   { opacity: 1; transform: translateY(0); }
}

</style>
